<template>
  <transition name="el-drawer-fade" @after-enter="afterEnter" @after-leave="afterLeave">
    <div
      :class="[request_prefix == 'appStage' ? 'el-drawer-mobile__wrapper' : 'el-drawer__wrapper', direction === 'center' ? 'noAnimate' : '',
      zoom < 1 ?'zoomOut' : '']"
      tabindex="-1"
      v-show="visible"
      :style="drawerZoomStyle"
    >
      <div
        class="el-drawer__container"
        :class="visible && 'el-drawer__open'"
        @click.self="handleWrapperClick"
        role="document"
        tabindex="-1"
        :style="modalStyle"
      >
        <div class="bg-zoom" v-if="zoom < 1"></div>
        <div
          aria-modal="true"
          aria-labelledby="el-drawer__title"
          :aria-label="title"
          class="el-drawer"
          :class="[direction, customClass]"
          :style="customeStyle"
          ref="drawer"
          role="dialog"
          tabindex="-1"
        >
          <header class="el-drawer__header" id="el-drawer__title" v-if="withHeader">
            <slot name="title">
              <span role="heading" :title="title">{{ title }}</span>
            </slot>
            <button
              :aria-label="`close ${title || 'drawer'}`"
              class="el-drawer__close-btn"
              type="button"
              v-if="showClose"
              @click="closeDrawer"
            >
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>
          </header>
          <section class="el-drawer__body" v-if="rendered">
            <slot></slot>
          </section>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Popup from "./utils/popup"
import emitter from "./mixins/emitter"

export default {
  name: "cxDrawer",
  mixins: [Popup, emitter],
  props: {
    appendToBody: {
      type: Boolean,
      default: false
    },
    beforeClose: {
      type: Function
    },
    customClass: {
      type: String,
      default: ""
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: true
    },
    direction: {
      type: String,
      default: "rtl",
      validator(val) {
        return ["ltr", "rtl", "ttb", "btt", "center"].indexOf(val) !== -1
      }
    },
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    size: {
      type: [Number, String],
      default: "30%"
    },
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean
    },
    wrapperClosable: {
      type: Boolean,
      default: true
    },
    withHeader: {
      type: Boolean,
      default: true
    },
    customeStyle: {
      type: Object,
      default: () => ({})
    },
    modalStyle: {
      type: Object,
      default: () => ({})
    },
    zoom: {
      type: Number,
      default: 1
    },
  },
  computed: {
    isHorizontal() {
      return this.direction === "rtl" || this.direction === "ltr"
    },
    sizeStyle() {
      const size = typeof this.size === "number" ? `${this.size}px` : this.size
      return this.isHorizontal ? `width: ${size}` : `height: ${size}`
    },
    drawerZoomStyle() {
      if (this.request_prefix === "appStage") {
        let val1 = 213
        let str1 = "calc(50% - 213px)"
        if(this.$store.state.states.showLeftMenus){
          str1 = this.zoom === 1 ? "calc(50% - 213px)" : "calc(50% - "+ Number(val1 + 115 * (this.zoom - 1)).toFixed(0) +"px)"
        }else{
          str1 = this.zoom === 1 ? "calc(50% - 322px)" : "calc(50% - "+ Number(val1 - 1 + 110 * this.zoom).toFixed(0) +"px)"
        }
        //为了解决缩小时，抽屉底部是空白的问题
        let width1 = parseFloat(this.customeStyle.width) * this.zoom
        return {
          "--zoomValue": str1,
          width: 414 * this.zoom + "px",
          "--bgZoomWidth": width1 + "px",
          "--bgBorderWidth": "3px"
        }
      } else {
        return {
          "--bgZoomWidth": 0,
          "--bgBorderWidth": 0
        }
      }
    },
  },
  data() {
    return {
      closed: false,
      prevActiveElement: null,
      rendered: false
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.closed = false
        this.$emit("open")
        if (this.appendToBody) {
          document.body.appendChild(this.$el)
        }
        this.prevActiveElement = document.activeElement
      } else {
        if (!this.closed) {
          this.$emit("close")
          if (this.destroyOnClose === true) {
            this.rendered = false
          }
        }
        this.$nextTick(() => {
          if (this.prevActiveElement) {
            this.prevActiveElement.focus()
          }
        })
      }
    }
  },
  methods: {
    afterEnter() {
      this.$emit("opened")
    },
    afterLeave() {
      this.$emit("closed")
    },
    hide(cancel) {
      if (cancel !== false) {
        this.$emit("update:visible", false)
        this.$emit("close")
        if (this.destroyOnClose === true) {
          this.rendered = false
        }
        this.closed = true
      }
    },
    handleWrapperClick() {
      if (this.wrapperClosable) {
        this.closeDrawer()
      }
    },
    closeDrawer() {
      if (typeof this.beforeClose === "function") {
        this.beforeClose(this.hide)
      } else {
        this.hide()
      }
    },
    handleClose() {
      // This method here will be called by PopupManger, when the `closeOnPressEscape` was set to true
      // pressing `ESC` will call this method, and also close the drawer.
      // This method also calls `beforeClose` if there was one.
      this.closeDrawer()
    }
  },
  mounted() {
    if (this.visible) {
      this.rendered = true
      this.open()
      if (this.appendToBody) {
        document.body.appendChild(this.$el)
      }
    }
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer {
  -webkit-box-shadow: none;
  box-shadow: none;
}
::v-deep .customDrawer {
  background-color: rgba(255, 255, 255, 0) !important;
  .page-layout-wrapper {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    &::before {
      border: 0px !important;
    }
  }
}
.zoomOut ::v-deep .customDrawer{
  border-bottom: 0 !important;
}
.el-drawer__wrapper {
  position: fixed;
  top: 50px;
  right: 260px;
  bottom: 0;
  left: 220px;
  overflow: hidden;
  margin: 0;
  &.noAnimate {
    animation: none;
  }
  .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
  }
}
.el-drawer-mobile__wrapper {
  position: fixed;
  top: 50px;
  width: 414px;
  bottom: 0;
  /*left: calc(50% - 213px);*/
  left: var(--zoomValue);
  overflow: hidden;
  margin: 0;
  .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
  }
}
.el-drawer__body {
  overflow: visible; //用于显示工具栏
}
.el-drawer.center {
  display: none;
}
.el-drawer__open .el-drawer.center {
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  display: block;
}
.bg-zoom{
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: var(--bgZoomWidth);
  background-color: white;
  border: var(--bgBorderWidth) solid rgb(61, 130, 242);
}
</style>
